import React from 'react'
import qs from 'query-string'
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom'
import isNull from 'lodash.isnull'

import { ROUTE } from '@enums/route'
import { AUTH_STATE } from '@enums/auth-state'
import { useAuthState } from '@contexts/AuthState'
import { useOktaAuth } from '@okta/okta-react'

const PrivateRoute: React.FC<RouteProps> = ({ component }) => {
  const appAuthState = useAuthState()
  const { authState } = useOktaAuth()
  const { pathname } = useLocation()
  const ProtectedComponent = component as React.FC

  const { search } = useLocation()
  const { form_success } = qs.parse(search)

  return (
    <Route
      path={pathname}
      render={() => {
        /**
         * don't render anything until we have a definitive AUTH_STATE enum value
         * this process is pretty instantaneous — don't show a spinner
         */
        if (isNull(appAuthState)) {
          return null
        }

        if(form_success) {
          return <Redirect to={{
            pathname: ROUTE.newHome,
            search:`?formSuccess=${form_success === 'true'}`
          }} />
        }

        if (appAuthState === AUTH_STATE.AUTHD || authState.isAuthenticated) {
          return <ProtectedComponent />
        }

        return <Redirect to={ROUTE.logIn} />
      }}
    />
  )
}

export default PrivateRoute
